import React from 'react';
import AbacusContext from '../../abacus/abacus-context';

// helper that is exported only for testing!
// abacusTestsToProps is a map of abacus test names to desired prop names
// abacus is the abacus slice from redux
export function mapTestValuesToProps(abacusTestsToProps, abacus) {
    const props = {};
    for (let test in abacusTestsToProps) {
        if (abacusTestsToProps.hasOwnProperty(test)) {
            const prop = abacusTestsToProps[test];
            // default missing test values to 0
            props[prop] = (abacus[test] && abacus[test].value)
                ? abacus[test].value
                : 0;
        }
    }
    return props;
}

// Main HOC
// function => function => Component
function withAbacusTestValuesAsProps(abacusTestsToProps) {
    return function(Component) {
        return function(props) {
            return (
                <AbacusContext.Consumer>
                    {(abacus) => {
                        const abacusProps = mapTestValuesToProps(abacusTestsToProps, abacus);
                        const mergedProps = {
                            ...props,
                            ...abacusProps
                        };
                        return <Component {...mergedProps}/>;
                    }}
                </AbacusContext.Consumer>
            );
        };
    };
}
export default withAbacusTestValuesAsProps;



// WEBPACK FOOTER //
// ./src/universal/abacus/with-abacus-test-values-as-props/with-abacus-test-values-as-props.js